<script>
import CustomTable from "../../../../components/tables/custom-table.vue";
import CustomerTaskScheduleForm from "../forms/customer-task-schedule-form";
import AddButton from "../../../../components/buttons/add-button.vue";
import Months from "../../../../helpers/general/months";
import DaysOfWeek from "../../../../helpers/general/days-of-week";

/**
 * Customers Component
 */
export default {
    props: {
      customer_task_id: Number
    },
  components: {
    CustomTable,
    CustomerTaskScheduleForm,
    AddButton
  },
  data() {
    return {
      formModalId:'customer-task-schedule-show-form-modal',
      table:{
        url:'/customer-task-schedules',        
        fields:[
          { key: "id", label: "Cod", sortable: false },
          { key: "frequency", label: "Frequency", sortable: false },
          { key: "month", label: "Month", sortable: false },
          { key: "day_of_month", label: "Day of month", sortable: false },
          { key: "day_of_week", label: "Day of week", sortable: false },
          { key: "hour", label: "Hour", sortable: false },
          { key: "minute", label: "Minute", sortable: false },
        ],
        formatted_fields:[
          'month',
          'day_of_week',
        ]
      }, 
      formSelectedItemId:null,   
    };
  },
  computed:{
    params(){
      return {customer_task_id: this.customer_task_id};
    }
  },
  methods: {
    showEditModal(item) {
      this.formSelectedItemId = item?.id || null;
      this.$bvModal.show(this.formModalId);
    },
    onSuccess(){
      this.$refs.customerTaskScheduleShowTable.refresh();
    },
    formatter(field, item){
      switch(field){
        case 'month':
        {
          return Months.getMonth(item?.month);
        }
        case 'day_of_week':
        {
          return DaysOfWeek.getDayOfweek(item?.day_of_week);
        }
      }

      return '';
    }
  }
};
</script>

<template>
  <div class="card">
      <div class="card-body">
          <CustomerTaskScheduleForm :modal-id="formModalId" :customer-task-id="customer_task_id" :id="formSelectedItemId" @onSuccess="onSuccess"></CustomerTaskScheduleForm>
          <h4 class="card-title mb-4">Task Schedules 
            <div class="text-right">
              <AddButton @click="showEditModal"></AddButton>
            </div>
          </h4>
          
          <CustomTable
            :url="table.url"
            :fields="table.fields"   
            :formatted-fields="table.formatted_fields"
            :formatter="formatter"
            @edit="showEditModal"        
            :params="params"   
            :show-delete="true"    
            :containerTableClass="'max-h-250'"
            ref="customerTaskScheduleShowTable"
          >              
          </CustomTable>
      </div>
  </div>
</template>